import { Button, Space, Tag, Popconfirm } from "antd";
import { EyeOutlined, EditOutlined, StopOutlined, PrinterOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { docLinkRender } from "../../../components/table/DocLink";

export const JU_PENDING = "รอยืนยัน";
export const JU_CONFIRMED = "รับเข้าสต๊อกแล้ว";
export const JU_CANCELLED = "ยกเลิก";
export const JU_STATUS = [JU_PENDING, JU_CONFIRMED, JU_CANCELLED];

export const StatusTag = ({ value }) => {
  const color =
    value === JU_CONFIRMED ? "green" : value === JU_CANCELLED ? "default" : "orange";
  return <Tag color={color}>{value || "-"}</Tag>;
};

export const num = (v, d = 3) =>
  Number(v || 0).toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: d });

export const fdate = (v) => (v ? dayjs(v).format("DD/MM/YYYY") : "");

export const printTags = (jucode) =>
  window.open(`/ju-tags-print/${encodeURIComponent(jucode)}`, "_blank");

export const accessColumn = ({ handleView, handleEdit, handleCancel }) => [
  {
    title: "เลขที่ JU",
    dataIndex: "jucode",
    key: "jucode",
    width: 140,
    render: docLinkRender(handleView, "เปิดดูเอกสาร JU"),
  },
  { title: "วันที่", dataIndex: "judate", key: "judate", width: 110, render: fdate },
  { title: "สินค้า", dataIndex: "item_names", key: "item_names", ellipsis: true },
  { title: "จำนวนรายการ", dataIndex: "item_count", key: "item_count", width: 110, align: "right" },
  {
    title: "สถานะ",
    dataIndex: "doc_status",
    key: "doc_status",
    width: 140,
    align: "center",
    render: (v) => <StatusTag value={v} />,
  },
  { title: "สร้างโดย", dataIndex: "created_name", key: "created_name", width: 160 },
  { title: "หมายเหตุ", dataIndex: "remark", key: "remark", ellipsis: true },
  {
    title: "Action",
    key: "action",
    fixed: "right",
    width: 160,
    render: (_, r) => (
      <Space>
        <Button size="small" icon={<EyeOutlined />} className="bn-success-outline" title="ดูข้อมูล" onClick={() => handleView(r)} />
        {r.doc_status === JU_PENDING && (
          <Button size="small" icon={<EditOutlined />} className="bn-primary-outline" title="แก้ไข / ยืนยันรับเข้าสต๊อก" onClick={() => handleEdit(r)} />
        )}
        {r.doc_status !== JU_CANCELLED && (
          <Button size="small" icon={<PrinterOutlined />} className="bn-warning-outline" title="พิมพ์ Tags" onClick={() => printTags(r.jucode)} />
        )}
        {r.doc_status !== JU_CANCELLED && (
          <Popconfirm
            placement="topRight"
            title="ยกเลิกเอกสารนี้?"
            description={r.doc_status === JU_CONFIRMED ? "ระบบจะถอนสินค้าออกจากสต๊อก (ถ้ายังไม่ถูกเบิกใช้)" : undefined}
            okText="ยกเลิกเอกสาร"
            cancelText="ไม่"
            onConfirm={() => handleCancel(r)}
          >
            <Button size="small" danger icon={<StopOutlined />} title="ยกเลิก" />
          </Popconfirm>
        )}
      </Space>
    ),
  },
];
